var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAspireCollegeShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 241,
    viewBox: "0 0 215 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2110_68256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.638 206.347C-0.972731 172.621 -7.88529 125.746 12.082 86.2773C29.1957 52.4491 57.2335 33.7896 94.4802 28.2227C58.7597 38.4888 33.0777 60.0364 21.3633 95.6838C9.5976 131.487 16.193 164.677 40.723 193.317C61.9524 218.104 89.6222 229.549 122.327 227.785C154.97 226.024 180.381 210.745 200.116 185.137C186.289 210.277 165.834 227.597 138.321 235.468C96.6793 247.38 60.4571 237.164 29.638 206.347Z",
    fill: "#C49A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.598 83.1123C115.753 84.9247 117.797 87.2781 119.457 90.0457C133.6 113.618 147.787 137.164 161.884 160.764C163.032 162.686 164.692 164.507 164.569 167.719C158.507 168.41 152.427 168.236 146.37 167.802C144.127 167.642 143.371 165.371 142.351 163.676C130.409 143.832 118.505 123.965 106.52 104.148C102.078 96.8015 97.8612 96.9465 93.4161 104.369C81.4338 124.378 69.3873 144.349 57.463 164.392C55.9278 166.973 54.0989 168.366 51.058 168.139C45.8487 167.751 40.5222 168.849 35.4203 167.397C35.1575 164.68 36.7016 163.19 37.6845 161.543C51.7737 137.938 66.2719 114.567 79.8879 90.6934C85.8687 80.2068 101.035 78.1867 112.598 83.1123Z",
    fill: "#C49A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.107 46.6478C191.383 48.2226 190.799 49.4176 190.187 50.5985C188.303 54.2346 186.293 54.7889 182.925 51.7991C174.791 44.5785 165.733 38.6519 155.524 34.7411C151.56 33.2225 151.452 31.2406 153.473 27.9725C159.066 18.9289 170.548 15.3137 180.558 19.6357C190.672 24.0021 195.35 34.6694 192.107 46.6478Z",
    fill: "#C49A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.816 155.009C92.7281 154.128 87.9209 150.212 86.8374 143.993C85.7857 137.958 88.7019 132.235 94.2134 129.517C100.934 126.203 109.162 129.219 112.199 136.108C115.252 143.033 112.007 151.228 105.077 153.95C103.848 154.433 102.51 154.636 100.816 155.009Z",
    fill: "#C49A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.457 14.4028C207.962 17.2559 204.566 17.601 201.151 15.1929C197.935 12.9245 197.031 9.63727 198.023 5.97622C198.93 2.62762 201.39 0.710645 204.815 0.281477C208.248 -0.148745 210.976 1.19986 212.797 4.15217C214.998 7.72151 214.516 11.0631 211.457 14.4028Z",
    fill: "#C49A6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2110_68256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 215,
    height: 241,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAspireCollegeShort);
export default __webpack_public_path__ + "static/media/AspireCollegeShort.5936de366cd4dba74f9379156dcb7443.svg";
export { ForwardRef as ReactComponent };